import debounce from '../utils/debounce.js';
import handleize from '../utils/handleize.js';
import EVENT from '../enums/event.js';

class ProductNavigation extends HTMLElement {
  constructor() {
    super();

    this.selectFrame = document.querySelector('[data-select-frame]');
    this.productNavigation = document.querySelector(
      '[data-product-navigation]'
    );

    this.currentScrollPos = window.pageYOffset;
    this.breakpoint = window.matchMedia('(max-width:768px)');
    this.header = document.getElementById('shopify-section-header');

    this.debouncedScrollHandler = debounce(() => this.scrollHandler(), 100);
    window.addEventListener('touchmove', this.debouncedScrollHandler);
    window.addEventListener('scroll', this.debouncedScrollHandler);

    document.addEventListener(EVENT.HEADER.HIDDEN, () => {
      this.moveNavigation(true);
    });

    document.addEventListener(EVENT.HEADER.VISIBLE, () => {
      this.moveNavigation(false);
    });

    const nav = document.querySelector('[data-section-title-nav]');
    this.titles = [...document.querySelectorAll('[data-section-title]')];

    this.titles.forEach(el => {
      const element = el;
      element.dataset.sectionTitle = handleize(el.innerText);
    });

    nav.innerHTML = this.titles
      .map(el => {
        return `<li data-scroll="${handleize(
          el.innerText
        )}" data-section-title="${el.innerText}" data-product-navigation-link>${
          el.innerText
        }</li>`;
      })
      .join(' ');
    this.productNavAnchor = document.querySelectorAll('[data-scroll]');
    this.scrollToLinkHandler();
    this.addIntersectionObservers();
  }

  static shouldShowNavigation() {
    return window.pageYOffset >= 1000;
  }

  showNavigation() {
    this.productNavigation.dataset.state = 'visible';
  }

  hideNavigation() {
    setTimeout(() => {
      this.productNavigation.dataset.state = 'hidden';
      this.productNavigation.style.top = '0px';
    }, 100);
  }

  moveNavigation(headerHidden) {
    if (ProductNavigation.shouldShowNavigation()) {
      if (headerHidden || !this.breakpoint.matches) {
        this.productNavigation.style.top = '0px';
      } else {
        this.productNavigation.style.top = '70px';
      }
    }
  }

  scrollHandler = () => {
    if (ProductNavigation.shouldShowNavigation()) {
      this.showNavigation();
    } else {
      this.hideNavigation();
    }
  };

  scrollToLinkHandler() {
    this.productNavAnchor.forEach(link => {
      const productNavTarget = link.getAttribute('data-scroll');
      link.addEventListener('click', () => {
        document
          .querySelector(`[data-section-title="${productNavTarget}"]`)
          .scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    if (this.selectFrame) {
      this.selectFrame.addEventListener('click', () => {
        document
          .querySelector('[data-option-selector]')
          .scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  addIntersectionObservers() {
    this.titles.forEach(title => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(
          entry => {
            if (entry.isIntersecting) {
              // Deactivate all the links...
              this.productNavAnchor.forEach(link => {
                const l = link;
                l.setAttribute('data-active', 'false');
              });

              // Activate the link we are currently looking at...
              const productNavTarget = title.getAttribute('data-section-title');
              const activeLink = document.querySelector(
                `[data-product-navigation-link][data-scroll="${productNavTarget}"]`
              );
              activeLink.setAttribute('data-active', 'true');
            }
          },
          {
            threshold: 1,
          }
        );
      });

      observer.observe(title);
    });
  }
}

customElements.define('product-navigation', ProductNavigation);
